import { default_state } from './const'
import { copy } from '@/config/helper'

const state = copy(default_state)

export {
	state
};